import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './datadogRUM-init';
import App from './App';
import * as serviceWorker from './serviceWorker';

// IMPEDE USUARIO DE INSERIR QUALQUER CARACTER OU PALAVRA ANTES DO #, POIS O REACT USA A PARTIR DO #, LOGO ANTES TEM QUE SEMPRE ESTAR CLEAN
if (window.location.pathname !== '/') {
  window.location.pathname = '/';
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
